import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import ContentLoading from '../components/widgets/content_loading';
import '../components/winners/style.scss';

class Winner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            draw_number: 1,
            showTable: false,
        };
    }

    async componentDidMount() {
        await this.props.actions.winnerActions.getDrawings();
        this.setState({
            showTable: true,
        });
    }

    render() {
        const { drawings = [] } = this.props.winner;
        const draw_number = this.state.draw_number;

        const renderTitle = (drawings, draw_number) => {
            if (drawings.length > 0) {
                let draw = drawings.filter(drawing => {
                    return drawing.draw_number == draw_number;
                });

                if (
                    draw &&
                    draw.length > 0 &&
                    draw[0].winners &&
                    draw[0].winners.length > 0
                ) {
                    return (
                        <div className="lottery-message">
                            <h3>Five (5) $1,000 Winners</h3>
                        </div>
                    );
                } else {
                    return null;
                }
            }
        };

        const renderWinners = (drawings, draw_number) => {
            if (!this.state.showTable) return null;

            if (drawings.length > 0) {
                let draw = drawings.filter(drawing => {
                    return drawing.draw_number == draw_number;
                });

                if (
                    draw &&
                    draw.length > 0 &&
                    draw[0].winners &&
                    draw[0].winners.length > 0
                ) {
                    return (
                        <tbody>
                            {draw[0].winners.map(function(winner, index) {
                                return (
                                    <tr key={index}>
                                        <td data-title="Winner">{1 + index}</td>
                                        <td data-title="Winner&#39;s Name">
                                            {winner.first_name}{' '}
                                            {winner.last_name}
                                        </td>
                                        <td data-title="City, State">
                                            {winner.city}, {winner.state}
                                        </td>
                                        <td data-title="Prize">
                                            {winner.prize}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    );
                } else {
                    return renderPreTable();
                }
            } else {
                return renderPreTable();
            }
        };

        const renderPreTable = () => {
            return (
                <tbody>
                    <tr>
                        <td data-title="Winner">Winner 1</td>
                        <td data-title="Winner&#39;s Name">TBD</td>
                        <td data-title="City, State">TBD</td>
                        <td data-title="Prize">$1,000</td>
                    </tr>
                    <tr>
                        <td data-title="Winner">Winner 2</td>
                        <td data-title="Winner&#39;s Name">TBD</td>
                        <td data-title="City, State">TBD</td>
                        <td data-title="Prize">$1,000</td>
                    </tr>
                    <tr>
                        <td data-title="Winner">Winner 3</td>
                        <td data-title="Winner&#39;s Name">TBD</td>
                        <td data-title="City, State">TBD</td>
                        <td data-title="Prize">$1,000</td>
                    </tr>
                    <tr>
                        <td data-title="Winner">Winner 4</td>
                        <td data-title="Winner&#39;s Name">TBD</td>
                        <td data-title="City, State">TBD</td>
                        <td data-title="Prize">$1,000</td>
                    </tr>
                    <tr>
                        <td data-title="Winner">Winner 5</td>
                        <td data-title="Winner&#39;s Name">TBD</td>
                        <td data-title="City, State">TBD</td>
                        <td data-title="Prize">$1,000</td>
                    </tr>
                </tbody>
            );
        };

        const renderDrawings = () => {
            return (
                <>
                    <div className="lottery-message">
                        <p>
                            <strong>
                                The Lottery will post the names of the winners
                                on the website no later than 3:00 p.m. on
                                2/5/2021.
                            </strong>
                        </p>
                    </div>
                    {renderTitle(drawings, draw_number)}
                    <div className="row">
                        <table className="table-panelled">
                            <thead>
                                <tr>
                                    <th>Winner</th>
                                    <th>Winner&#39;s Name</th>
                                    <th>City, State</th>
                                    <th>Prize</th>
                                </tr>
                            </thead>
                            {renderWinners(drawings, draw_number)}
                        </table>
                    </div>
                    <div className="lottery-message">
                        <p>
                            <strong>
                                Entries must be submitted prior to 11:59:59 pm
                                (MT) on January 31, 2021.
                            </strong>
                        </p>
                        <h2>IMPORTANT! HOLD ONTO YOUR TICKET(S).</h2>
                        <h4>
                            YOU WILL NEED TO PRESENT IT TO IDAHO LOTTERY
                            OFFICIALS IF YOU ARE SELECTED AS A WINNER.
                        </h4>
                    </div>
                    <div className="lottery-message text-left">
                        <p>
                            <strong>Important winner details:</strong>
                            <br />
                            <br />
                            The winner will have five (5) business days after
                            notification to contact Idaho Lottery Customer
                            Service. Every effort will be made to contact the
                            winner by phone and the e-mail information that was
                            provided by entrant.
                            <br />
                            <br />
                            In the event a named winner is disqualified or does
                            not step forward to claim their prize within the
                            required time, the named winner will forfeit their
                            claim to the prize and an alternate will be chosen
                            and contacted. The alternate will then have
                            forty-eight (48) hours from notification to claim
                            their prize.
                        </p>
                    </div>
                </>
            );
        };

        return (
            <Layout
                user={this.props.user}
                notification={this.props.notification}
                actions={this.props.actions}
            >
                <SEO title="Winners" />
                <h1 className="title-section text-center">Winners</h1>
                <ContentLoading hasIcon={true} loadedAction="getDrawings">
                    <div className="page-content winners">
                        {renderDrawings()}
                    </div>
                </ContentLoading>
            </Layout>
        );
    }
}

Winner.propTypes = {
    drawings: PropTypes.any,
    winner: PropTypes.any,
    user: PropTypes.any,
    notification: PropTypes.any,
    actions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(Winner);
